import { ListingSellerDraftModel } from '@steelbuy/ts-shared';

import { createCollectionDataContext } from '../../util/provider/CollectionDataProvider';

export const ListingSellerDraftCollectionData = createCollectionDataContext<ListingSellerDraftModel>();
